import { render, staticRenderFns } from "./AccountHeaderWithImport.vue?vue&type=template&id=70783dd4&scoped=true&"
import script from "./AccountHeaderWithImport.vue?vue&type=script&lang=js&"
export * from "./AccountHeaderWithImport.vue?vue&type=script&lang=js&"
import style0 from "./AccountHeaderWithImport.vue?vue&type=style&index=0&id=70783dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70783dd4",
  null
  
)

export default component.exports